import React from 'react';
import { Route, Routes } from 'react-router-dom'
import { PriceAdjustmentContainer } from '../../../Containers/Settings/Voss/PriceAdjustmentContainer';
import { PriceAdjustmentFormContainer } from '../../../Containers/Settings/Voss/PriceAdjustmentFormContainer';

export default function PriceAdjustmentLayout() {

    return <Routes>
        <Route path={'/edit'} element={<PriceAdjustmentFormContainer />} />
        <Route index element={<PriceAdjustmentContainer/>} />
    </Routes>
}